<template>
    <div>
        <v-card>
            <v-card-title>
                <span class="text-h5">Solicitud Masiva: {{ reference }}</span>
                <v-spacer></v-spacer>
                <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar" single-line
                    hide-details></v-text-field>
            </v-card-title>
            <v-card-text>
                <v-container>
                    <v-data-table :headers="headers" :items="allEmployees" :items-per-page=-1
                        class="elevation-1 custom-font" :loading="load" loading-text="Cargando... Espere por favor"
                        :search="search" v-model="selected" show-select @toggle-select-all="disableRow">
                        <!-- <template v-slot:item.setRef="{ item }">
                            <v-chip v-if="item.setRef !== '-'" color="green" text-color="white">{{ item.setRef }} {{ item.setPosition }}</v-chip>
                            <v-chip v-else color="warning" text-color="white">Sin Set</v-chip>
                        </template> -->
                        <template v-slot:item.setRef="{ item }">
                            <v-menu offset-y v-if="item.setRef !== '-'">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-chip color="green" text-color="white" v-bind="attrs" v-on="on" class="pointer">
                                        {{ item.setRef }} {{ item.setPosition }}
                                        <v-icon right small>mdi-chevron-down</v-icon>
                                    </v-chip>
                                </template>
                                <v-list>
                                    <v-list-item v-for="(opt, index) in item.set" :key="index"
                                        @click="item.setRef = opt.ref; item.setPosition = opt.items[0].position; item.zoneId = opt.zoneId">
                                        <v-list-item-title>{{ opt.ref }} {{ opt.items[0].position }}</v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>

                            <v-chip v-else color="warning" text-color="white">Sin Set</v-chip>
                        </template>
                        <template v-slot:item.data-table-select="{ item, isSelected, select }">
                            <v-simple-checkbox :value="isSelected" :readonly="item.setRef === '-'"
                                :disabled="item.setRef === '-'" @input="select($event)"></v-simple-checkbox>
                        </template>
                    </v-data-table>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-alert shaped dense dark type="info" v-if="info !== ''">
                    {{ info }}
                </v-alert>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="cancelStock">
                    Cancelar
                </v-btn>
                <v-btn :disabled="!isOk" color="blue darken-1" text @click="saveStock">
                    Solicitar
                </v-btn>
            </v-card-actions>
        </v-card>
    </div>
</template>
<script>
import swal from "sweetalert"
import { getEmployeesWithKits, getKitsByEmployeeCache, saveRequest, getProductsByCategoryAndSex } from '../dataApi'
import UserProfile from "../data";
export default {
    name: 'requestKits',
    data: () => ({
        user: UserProfile.getUserData(),
        selectedRef: null,
        selectedKit: null,
        product: 0,
        quantity: 0,
        employee: null,
        reference: `Set-${Date.now().toString().slice(-7)}`,
        itemsProducts: [],
        itemsEmployees: [],
        employees: [],
        allEmployees: [],
        itemsKits: [],
        allKits: [],
        productsAggregate: [],
        disableRef: false,
        originLabel: null,
        headers: [
            { text: 'Nombre', value: 'firstName' },
            { text: 'Apellido', value: 'fatherName' },
            { text: 'Posicion', value: 'position' },
            { text: 'Centro de Costo', value: 'costCenter' },
            { text: 'Set', value: 'setRef' },
        ],
        info: "",
        search: "",
        selected: [],
        load: false,
        selectAll: false,
    }),

    methods: {
        async createdValuesItems() {
            this.load = true
            setTimeout(async () => {
                this.allEmployees = await getEmployeesWithKits();
                this.load = false
            }, 500)
        },

        async onList() {
            const kit = await getKitById(this.selectedKit)
            kit.items.forEach(async item => {
                const employeesFiltered = await getFilteredEmployees({
                    position: item.position,
                    costCenter: kit.costCenter,
                    gender: item.sex
                })
                employeesFiltered.forEach(employee => {
                    const exist = this.productsAggregate.findIndex(product => product.employeeId === employee.value && product.categoryId === item.category.id)
                    if (exist !== -1) {
                        this.productsAggregate[exist].quantity += item.quantity;
                    } else {
                        this.productsAggregate.push({
                            categoryId: item.category.id,
                            category: item.category.name,
                            quantity: item.quantity,
                            employeeId: employee.value,
                            employee: employee.text,
                            note: "automatizado",
                        })
                    }
                })

            })
        },

        async onCalculate() {
            const quantity = parseInt(this.quantity)
            const product = this.itemsProducts.find(product => product.value === this.product)
            const employee = this.itemsEmployees.find(employee => employee.value === this.employee)
            const exist = this.productsAggregate.findIndex(product => product.productId === this.product && product.employeeId === this.employee)
            if (exist !== -1) {
                this.productsAggregate[exist].quantity += quantity;
            } else {
                this.productsAggregate.push({
                    productId: this.product,
                    product: product.text,
                    quantity,
                    employeeId: this.employee,
                    employee: employee.text,
                    note: this.reference,
                });
            }
            this.quantity = 0;
            this.product = 0;
            this.disableRef = true;
            if (!this.originLabel) {
                const origin = this.itemsProviders.find(provider => provider.value === this.provider)
                if (origin) this.originLabel = origin.text
            }
        },

        deleteItem(item) {
            const index = this.productsAggregate.findIndex(product => product.id === item.id)
            if (index !== -1) {
                this.productsAggregate.splice(index, 1);
            }
        },

        onEdit() {
            this.disableRef = false;
            this.originLabel = null;
        },

        cancelStock() {
            this.$emit("closeModal")
        },

        async saveStock() {
            let flagZone = true;
            let zoneId = null;
            let invalidEmployees = [];
            const stock = {
                items: [],
                ref: this.reference
            }
            for await (const employee of this.selected) {
                if (employee.gender !== 'M' && employee.gender !== 'F') {
                    invalidEmployees.push(`${employee.firstName} ${employee.fatherName} ${employee.motherName} - ${employee.rut}`);
                }
                if (flagZone && !zoneId) zoneId = employee.zoneId;
                if (flagZone && zoneId !== employee.zoneId) flagZone = false;
                const setItems = employee.set.find(set => set.ref === employee.setRef)
                for await (const item of setItems.items) {
                    stock.items.push({
                        categoryId: item.category.id,
                        quantity: item.quantity,
                        finalEmployeeId: employee.id,
                        observation: 'Request Masivo' + this.reference,
                        sex: employee.gender
                    })
                }
            }
            if (!flagZone) {
                swal('', 'No se puede solicitar set/kits de diferentes zonas', 'error');
                return;
            }
            if (invalidEmployees.length > 0) {
                // Creamos una lista en HTML para que se vea ordenado
                const listHtml = `
                    <div style="text-align: left; margin-top: 10px;">
                        <p>Los siguientes empleados no tienen un género definido:</p>
                        <br>
                        <ul>
                            ${invalidEmployees.map(name => `<li>${name}</li>`).join('')}
                        </ul>
                    </div>
                `;

                swal({
                    title: 'Atención: Datos Incompletos',
                    content: {
                        element: "div",
                        attributes: {
                            innerHTML: listHtml,
                        },
                    },
                    icon: 'error',
                });

                return;
            }
            stock.zoneId = zoneId;

            await saveRequest(stock)
            this.cancelStock()
        },

        disableRow(items) {
            if (!this.selectAll) {
                this.selected = [];
                const self = this;
                items.items.forEach(item => {
                    if (item.setRef !== "-") self.selected.push(item)
                })
                this.selectAll = true;
            } else {
                this.selected = [];
                this.selectAll = false;
            }
        },
    },

    mounted() {
        this.createdValuesItems();
    },

    computed: {
        isNewItemOk() {
            return this.selectedKit
        },
        isOk() {
            return this.allEmployees.length > 0;
        },
        async calculatedEmployee() {
            const employees = []
            if (!this.selectedKit) return employees

        }
    },

    watch: {
        // async selectedKit(newValue, value){
        //     if(newValue === value || newValue === null) return
        //     const employees = []
        //     const kit = this.allKits.find(kit => kit.id === newValue)
        //     for await (const item of kit.items) {
        //         console.log("buscamos", item.costCenter, item.position)
        //         employees.push(...await getFilteredEmployees({
        //             position: item.position,
        //             costCenter: item.costCenter
        //         }))
        //     }
        //     this.itemsEmployees = employees;
        // }
        async employee(newValue, value) {
            if (newValue === value || newValue === null) return
            const emp = this.allEmployees.find(employee => employee.id === newValue)
            this.itemsKits = await getKitsByEmployee(emp);
        }
    }
}
</script>